var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('div',{staticClass:"w-full mt-[30px]",domProps:{"innerHTML":_vm._s(_vm.page.content)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }